import type { Control } from "react-hook-form";
import { ActiveFiltersSummary } from "web_myplann/Portfolio/Components/Redesign/Filter/ActiveFiltersSummary";
import { CategoryFilterSection } from "web_myplann/Portfolio/Components/Redesign/Filter/CategoryFilterSection";
import type { FilterFormValues } from "web_myplann/Portfolio/Components/Redesign/Filter/filterFormSchema";
import { SortFilterSection } from "web_myplann/Portfolio/Components/Redesign/Filter/SortFilterSection";

type Props = {
	control: Control<FilterFormValues>;
};

export const PortfolioFilterFormFields = ({ control }: Props) => (
	<>
		<CategoryFilterSection control={control} />
		<SortFilterSection control={control} />
		<ActiveFiltersSummary control={control} />
	</>
);
